"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrders = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.GetOrders = (0, graphql_tag_1.default) `
  query GetOrders($swapFrom: String!, $now: Datetime!) {
    orders(
      orderBy: EXPIRE_DATE_DESC
      filter: {
        status: { equalTo: ACTIVE }
        expireDate: { greaterThan: $now }
        tokenGive: { equalTo: $swapFrom }
      }
    ) {
      totalCount
      nodes {
        id
        sender
        status
      }
    }
  }
`;
//# sourceMappingURL=orders.generated.js.map